export interface Contact {
  id?: string
  type?: ContactType
  name?: string
  affiliation?: string
  email?: string
  content?: string
  accepted?: number
}

export type ContactType =
  'DATA_USAGE' |
  'LINKAGE' |
  'FEEDBACK' |
  'TECHNICAL' |
  'DATA_DEFECT' |
  'POLICY' |
  'OTHER'
export const CONTACT_TYPE_DEF: EnumDef = Object.freeze({
  id: 'jps-contact_type',
  c: {
    DATA_USAGE: {
      l: {
        ja: 'データの利用に関すること',
        en: 'About data use'
      },
      d: {}
    },
    LINKAGE: {
      l: {
        ja: 'ジャパンサーチとの連携に関すること',
        en: 'About joining Japan Search'
      },
      d: {}
    },
    FEEDBACK: {
      l: {
        ja: 'ジャパンサーチの改善要望について（フィードバック）',
        en: 'Feedbacks'
      },
      d: {}
    },
    TECHNICAL: {
      l: {
        ja: 'ジャパンサーチの技術仕様について',
        en: 'About technical details'
      },
      d: {}
    },
    DATA_DEFECT: {
      l: {
        ja: 'ジャパンサーチに収録されているデータの不備等に関すること',
        en: 'About data defect'
      },
      d: {}
    },
    POLICY: {
      l: {
        ja: 'サイトポリシー・プライバシーポリシーに関すること',
        en: 'About our policy'
      },
      d: {}
    },
    OTHER: {
      l: {
        ja: 'その他',
        en: 'Other'
      },
      d: {}
    }
  }
})
